import { FunctionComponent, useCallback, useEffect, useRef } from 'react';

const POLLING_INTERVAL_MS = 650;

export interface IBwjConscientiousContainerProps {
  className?: string | undefined;
  style?: React.CSSProperties | undefined;
  pollingFrequency?: number | undefined;
  onWidthChange?: (width: number, element: HTMLElement) => void;
  onHeightChange?: (height: number, element: HTMLElement) => void;
  onSizeChange?: (width: number, height: number, element: HTMLElement) => void;
}

export const BwjConscientiousContainer: FunctionComponent<IBwjConscientiousContainerProps> = (props) => {
  const { onWidthChange, onHeightChange, onSizeChange } = props;
  const pollingFrequency = props.pollingFrequency !== undefined ? props.pollingFrequency : POLLING_INTERVAL_MS;
  const containerRef = useRef<HTMLDivElement | null>(null);
  const intervalRef = useRef(0);

  const evalContainerSize = useCallback(() => {
    if(containerRef.current === null) { // not here yet, no problem - check in later
      intervalRef.current = window.setTimeout(evalContainerSize, 100);
      return;
    }

    const container = containerRef.current;
    const width = containerRef.current.clientWidth;
    const height = containerRef.current.clientHeight;

    if(!!onWidthChange) {
      onWidthChange(width, container);
    }
    if(!!onHeightChange) {
      onHeightChange(height, container);
    }
    if(!!onSizeChange) {
      onSizeChange(width, height, container);
    }

    intervalRef.current = window.setTimeout(evalContainerSize, pollingFrequency);
  }, [onWidthChange, onHeightChange, onSizeChange, pollingFrequency]);
  
  useEffect(() => {
    if(!onWidthChange && !onHeightChange && !onSizeChange) { return; }
    
    const ivRef = intervalRef;
    evalContainerSize();

    return () => {
      !!ivRef.current && window.clearTimeout(ivRef.current);
      ivRef.current = 0;
    };
  }, [evalContainerSize, onWidthChange, onHeightChange, onSizeChange]);

  return (
    <div ref={containerRef} className={props.className} style={props.style}>
      {props.children}
    </div>
  );
};